exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-div{padding-top:36px;-ms-flex-pack:center;justify-content:center;display:grid}.text{width:545px;font-size:16px;line-height:1.5;color:#162d3d;margin-bottom:30px}.buttons-div{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end}.buttons-div .btn-md{padding:0 32px}.cancel-button{margin-right:12px;border-color:#3899ec !important;border-width:1px !important;border-style:solid;color:#3899ec !important;background-color:#fff !important}.focus-panel-frame.tpa-settings-modal{height:252px !important}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/settings/components/share/share.scss
// module id = 460
// module chunks = 0 1